import { isImageFileEntry } from '../fields/core-field/media-attachment-field-props'
import { UI2IconName, UI2IconNames } from './ui2-icon-names'

const VIDEO_RE = /\.(mp4|mov|avi|mkv|wmv|webm|ogv)$/i
const SHEET_RE = /\.(xlsx?|csv|ods)$/i
const ARCHIVE_RE = /\.(zip|tar\.?gz?|rar|7z)$/i
const DOCUMENT_RE = /\.(pdf|docx?|odt|rtf|pptx?)$/i

/**
 * Glyph for a file entry in a chip list or viewer.
 *
 * One implementation because there used to be two, and they disagreed on more
 * than vocabulary: NM had no archive branch (a .zip drew the document glyph)
 * and the two fell back to different shapes. An unrecognised extension is a
 * paperclip — a generic attachment — never a document, so "we know this is a
 * PDF" and "we have no idea what this is" stay distinguishable.
 */
export function getFileTypeIcon(file: any): UI2IconName {
  const name = (file?.name || '').toLowerCase()
  const type = (file?.type || '').toLowerCase()
  if (type === 'image' || /^image/.test(type) || isImageFileEntry(file)) return UI2IconNames.IMAGE
  if (VIDEO_RE.test(name)) return UI2IconNames.FILM
  if (SHEET_RE.test(name)) return UI2IconNames.TABLE
  if (ARCHIVE_RE.test(name)) return UI2IconNames.FILE_ARCHIVE
  if (DOCUMENT_RE.test(name)) return UI2IconNames.FILE_TEXT
  return UI2IconNames.PAPERCLIP
}
